import { useNavigate } from 'react-router-dom';
import { useTranslation } from '../context/TranslationContext';
import { Navbar, Footer } from '../components/Layout';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';
import { XCircle } from 'lucide-react';

// PaymentSuccess used to live here — it was replaced by pages/ThankYou.jsx
// (routed at /thank-you, with /payment/success now redirecting there).

export const PaymentCancel = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-background" data-testid="payment-cancel-page">
      <Navbar />

      <main className="pt-20 pb-12">
        <div className="max-w-lg mx-auto px-6 py-20">
          <Card>
            <CardContent className="p-8 text-center">
              <XCircle className="w-16 h-16 mx-auto text-muted-foreground mb-6" />
              <h1 className="text-2xl font-serif font-medium mb-2">
                {t('pay_cancelled_title', 'Payment Cancelled')}
              </h1>
              <p className="text-muted-foreground mb-6">
                {t('pay_cancelled_desc', 'Your payment was cancelled. No charges were made.')}
              </p>
              <div className="flex flex-col gap-3">
                <Button onClick={() => navigate('/pricing')} className="rounded-full">
                  {t('pay_try_again', 'Try Again')}
                </Button>
                <Button onClick={() => navigate('/courses')} variant="outline" className="rounded-full">
                  {t('pay_browse_free', 'Browse Free Courses')}
                </Button>
              </div>
            </CardContent>
          </Card>
        </div>
      </main>

      <Footer />
    </div>
  );
};
